import { StyleSheet } from 'react-native';

import { widthPercentageToDP } from 'utils/responsiveness';

const styles = StyleSheet.create({
    contentContainer: {
        position: 'absolute',
        width: '100%',
        paddingHorizontal: widthPercentageToDP(16, 44, 72),
    },
});

export default styles;
